import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsFormControl, BsFormWithButtons } from '../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet, getSession } from '../utils/api';
import { swalert } from '../utils/notifications';

export default function Perfil(props) {
    const usuario = getSession();

    const updateData = async () => await apiGet(`usuarios/get/${usuario.id}`);

    const checkData = formData => {
        let errors = {};
        // Contraseña
        const password = formData.get("password");
        if (!password) {
            errors["password"] = "Campo obligatorio";
        }
        // Confirmar contraseña
        const confirmPassword = formData.get("confirmPassword");
        if ((password || confirmPassword) && password !== confirmPassword) {
            errors["confirmPassword"] = "Las contraseñas no coinciden";
        }
        return errors;
    }

    const saveData = async data => {
        const result = await apiForm("usuarios/changePassword", data);
        if (result) {
            swalert("Guardado", "Usuario guardado con éxito", "success");
        }
    }

    return <>
        <h2>Mi perfil</h2>
        <BsFormWithButtons
            saveBtnText="Cambiar contraseña"
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}>
            <PerfilForm />
        </BsFormWithButtons>
    </>;
}

function PerfilForm(props) {
    const data = props.data;
    const errors = props.errors;
    return <Row className="gy-3">
        { /* Nombre */}
        <Col md="6">
            <BsFormControl label="Nombre" value={data.name} readOnly />
        </Col>
        { /* Apellidos */}
        <Col md="6">
            <BsFormControl label="Apellidos" value={data.apellidos} readOnly />
        </Col>
        { /* Usuario */}
        <Col md="6">
            <BsFormControl label="Usuario" value={data.username} readOnly />
        </Col>
        { /* Email */}
        <Col md="6">
            <BsFormControl label="Email" value={data.email} readOnly />
        </Col>
        { /* Nueva contraseña */}
        <Col md="6">
            <BsFormControl
                label="Nueva contraseña" name="password"
                error={errors.password}
                type="password" isNewPassword />
        </Col>
        { /* Confirmar contraseña */}
        <Col md="6">
            <BsFormControl
                label="Confirmar contraseña" name="confirmPassword"
                error={errors.confirmPassword}
                type="password" isNewPassword />
        </Col>
    </Row>;
}
